import { css } from '@emotion/react'
import styled from '@emotion/styled'

const spinnerStyles = () => css`
  label: spinner;

  display: block;

  width: 25px;
  height: 25px;

  margin: 0px auto;

  animation: rotate 2s linear infinite;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`
const circleStyles = ({ theme, color }) => css`
  label: spinner__circle;

  stroke: ${color ? theme.colors[color] : 'currentColor'};
  stroke-linecap: round;

  animation: dash 1.5s ease-in-out infinite;
`

export const Spinner = styled('svg')(spinnerStyles)
export const Circle = styled('circle')(circleStyles)
